import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ToastProvider from './ToastProvider';
import "react-toastify/dist/ReactToastify.css";
import './i18n'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
     <ToastProvider>
    <App />
    </ToastProvider>
 ); 

reportWebVitals();